import { z } from 'zod';

/** Gateway families that use a per-OEM adapter Greengrass component + thing group. */
export const GatewayAdapterKindSchema = z.enum(['efem', 'location']);
export type GatewayAdapterKind = z.infer<typeof GatewayAdapterKindSchema>;

export const GatewayAdapterKeySchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9][a-z0-9._-]*$/)
  .transform((s) => s.toLowerCase());

export type GatewayAdapterKey = z.infer<typeof GatewayAdapterKeySchema>;

export interface GatewayAdapterKindMeta {
  kind: GatewayAdapterKind;
  deviceCategory: 'efem-gateway' | 'location-gateway';
  /** Dynamo attribute on CnapseDeviceInventory */
  dynamoAssignmentAttr: 'efemAdapterAssignment' | 'locationAdapterAssignment';
  /** Thing attribute key */
  iotAdapterKeyAttr: 'efemAdapterKey' | 'locationAdapterKey';
  iotAssignedAtAttr: 'efemAdapterAssignedAt' | 'locationAdapterAssignedAt';
}

export const GATEWAY_ADAPTER_KIND_META: Record<GatewayAdapterKind, GatewayAdapterKindMeta> = {
  efem: {
    kind: 'efem',
    deviceCategory: 'efem-gateway',
    dynamoAssignmentAttr: 'efemAdapterAssignment',
    iotAdapterKeyAttr: 'efemAdapterKey',
    iotAssignedAtAttr: 'efemAdapterAssignedAt',
  },
  location: {
    kind: 'location',
    deviceCategory: 'location-gateway',
    dynamoAssignmentAttr: 'locationAdapterAssignment',
    iotAdapterKeyAttr: 'locationAdapterKey',
    iotAssignedAtAttr: 'locationAdapterAssignedAt',
  },
};

export {
  toThingGroupSuffix,
  edgeThingGroup,
  tenantThingGroup,
  efemCategoryThingGroup,
  locationCategoryThingGroup,
  efemUnassignedThingGroup,
  locationUnassignedThingGroup,
  efemAdapterThingGroup,
  locationAdapterThingGroup,
  adapterThingGroupNameFromSuffix,
  thingGroupsForGateway,
  greengrassDeployTargetGroup,
  isManagedThingGroupName,
  type DeployProfileKey,
  type DeployTargetKind,
  type ThingGroupsForGatewayParams,
} from './iot-thing-groups.js';
